import { ToastClassInterface } from './types';

const baseClasses = {
  success: 'slime',
  error: 'red',
  warning: 'yellow',
  info: 'primary',
};

export const toastAlertClass: ToastClassInterface = {
  success: `!bg-${baseClasses.success}-25 !border-${baseClasses.success}-300`,
  error: `!bg-${baseClasses.error}-25 !border-${baseClasses.error}-300`,
  warning: `!bg-${baseClasses.warning}-25 !border-${baseClasses.warning}-300`,
  info: `!bg-${baseClasses.info}-25 !border-${baseClasses.info}-300`,
};

export const toastIconClass: ToastClassInterface = {
  success: `hover:bg-${baseClasses.success}-100 active:bg-${baseClasses.success}-200`,
  error: `hover:bg-${baseClasses.error}-100 active:bg-${baseClasses.error}-200`,
  warning: `hover:bg-${baseClasses.warning}-100 active:bg-${baseClasses.warning}-200`,
  info: `hover:bg-${baseClasses.info}-100 active:bg-${baseClasses.info}-200`,
};

export const toastMessageClass: ToastClassInterface = {
  success: `!text-${baseClasses.success}-700`,
  error: `!text-${baseClasses.error}-700`,
  warning: `!text-${baseClasses.warning}-700`,
  info: `!text-${baseClasses.info}-700`,
};

export const toastDescriptionClass: ToastClassInterface = {
  success: `!text-${baseClasses.success}-600`,
  error: `!text-${baseClasses.error}-600`,
  warning: `!text-${baseClasses.warning}-600`,
  info: `!text-${baseClasses.info}-600`,
};

export enum ToastSeverity {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}
